import styled from 'styled-components'
import { clamp } from '@styles/utils/conversion.style'
import { font } from '@styles/vars/font.style'
import { colors } from '@styles/vars/colors.style'
import { mq } from '@styles/vars/media-queries.style'

export const InformationMain =  styled.section`
  background-color: ${props => props.backgroundColor};
  h3, p {
    ${clamp('font-size', 22, 36)}
    ${clamp('margin-top', 20, 40)}
  }
`